import React from 'react';
import PineConeSvg from '../../images/pinecone.svg?react';
import { eBrandImageSizes } from './eBrandImageSizes';

export const LoadingImage: React.FC<{ imageSize?: eBrandImageSizes }> = ({ imageSize = eBrandImageSizes.Normal }) => {
  return <PineConeSvg className={imageSize} />;
};
